const breakpoints = require('../../services/breakpoints'),
	sizeMappings = require('../../services/sizeMappings'),
	targeting = require('../services/targeting'),
	pubsub = require('../../utils/pubsub');

/* Prep apntag */
window.apntag = window.apntag || {};
window.apntag.anq = window.apntag.anq || [];

const queueReady = new Promise((resolve) => {
	window.apntag.anq.push(() => {
		resolve();
	});
});

function _hookEvents() {
	window.apntag.onEvent('adError', (error, adObj) => {
		console.error('[ADVERT] Something went wrong in an ad creative for the ad ', adObj, ' | Error: ', error);
	});

	pubsub.subscribe('breakpoint.changed', () => {
		window.apntag.setPageOpts({
			'keywords': targeting.getPageTargeting()
		});
	});
}

async function init(settings) {
	performance.mark('advert - xandr - apntag.init - start');

	performance.mark('advert - xandr - apntag.cmd wait - start');
	await queueReady;
	performance.mark('advert - xandr - apntag.cmd wait - end');

	window.apntag.clearRequest();

	window.apntag.setPageOpts(_getPageOptionsFromSettings(settings));
	_hookEvents();

	performance.mark('advert - xandr - apntag.init - end');
}

function defineSlot(slot) {
	window.apntag.defineTag(_getTagValuesFromSlot(slot));
}

function _formatSizeMappingForXandr(sizeMap) {
	return Object.entries(breakpoints.getBreakpoints()).map(([bpName, bpBegin]) => ({
		'minWidth': bpBegin,
		'sizes': (sizeMap[bpName] || []).filter((s) => s !== 'fluid')
	}));
}

function loadSlots(slots = []) {
	const slotPromises = slots.map((s) => _waitForSingleSlotEvent(s, ['adRequested'], ['adRequestFailure']));

	window.apntag.loadTags(slots.map((s) => s.domId));

	return slotPromises;
}

function _waitForSingleSlotEvent(slot, events, failureEvents = []) {
	return new Promise((resolve, reject) => {
		events.forEach((event) => {
			window.apntag.onEvent(event, slot.domId, (...params) => {
				resolve(params);
			});
		});

		failureEvents.forEach((failureEvent) => {
			window.apntag.onEvent(failureEvent, slot.domId, (...params) => {
				reject(params);
			});
		});
	}).finally(() => {
		events.forEach((event) => {
			window.apntag.offEvent(event, slot.domId);
		});

		failureEvents.forEach((failureEvent) => {
			window.apntag.offEvent(failureEvent, slot.domId);
		});
	});
}

function renderSlot(slot) {
	window.apntag.modifyTag(slot.domId, _getTagValuesFromSlot(slot));

	const slotEventPromise = _waitForSingleSlotEvent(slot, ['adLoaded', 'adNoBid']);

	window.apntag.showTag(slot.domId);

	return slotEventPromise;
}

function refreshSlots(slots = []) {
	slots.forEach((slot) => {
		window.apntag.modifyTag(slot.domId, _getTagValuesFromSlot(slot));
	});

	const slotEventPromises = slots.map((slot) => _waitForSingleSlotEvent(slot, ['adLoaded', 'adNoBid']));

	window.apntag.refresh(slots.map((s) => s.domId));

	return slotEventPromises;
}

function _getPageOptionsFromSettings(/** Settings */ settings) {
	return {
		'member': settings.memberId,
		'enableSafeFrame': settings.enableSafeFrame,
		'disablePsa': settings.disablePSA,
		'keywords': targeting.getPageTargeting()
	};
}

function _getTagValuesFromSlot(/** Slot */ slot) {
	const placement = typeof slot.placement === 'object' ? slot.placement[breakpoints.getCurrentBreakpoint()] : slot.placement,
		placementKey = typeof placement === 'number' ? 'tagId' : 'invCode';

	return {
		'targetId': slot.domId,
		[placementKey]: placement,
		'sizeMapping': _formatSizeMappingForXandr(sizeMappings.getSizeMapping(slot.sizeMapping)),
		'keywords': targeting.getSlotTargeting(slot)
	};
}

function resizeSlot(slot, newSize) {
	window.apntag.resizeAd(slot.domId, newSize);
}

module.exports = {
	init,
	defineSlot,
	loadSlots,
	renderSlot,
	refreshSlots,
	resizeSlot
};
